import React,{ Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { signOut,getPedidos } from '../actions'
import Menu from '../components/user_menu'
import moment from 'moment'
require("moment/locale/es");
class Pedidos extends Component{
	
	constructor(props) {
    	super(props);
    	this.state = {
        	loading : false
      }
      moment.locale('es');
    }
    
    componentDidMount(){
    if(!this.props.usuario.user){
      this.props.history.push("/login")
    }
    this.props.getPedidos(this.props.usuario.user.uid)
  }

  componentDidUpdate(prevProps, prevState){

  }

	render() {  

		/*if(this.props.pedidos.pedidos.length<1){
			return <div>CARGANDO</div>
    }*/
    
    var listaPedidos = []
    if (this.props.pedidos.pedidos) {
      listaPedidos = this.props.pedidos.pedidos.map((pedido,i)=>{
        var data = Object.assign({},pedido);
        return <tr key={i}>
            <td>
              {moment.unix(pedido.fechaunix).format("DD.MM.YYYY HH:mm")}
            </td>
            <td dangerouslySetInnerHTML={{ __html: pedido.cuerpo }} />
            <td>
            ${(parseFloat(pedido.monto) + parseFloat(pedido.iva)).toFixed(2)}
            </td>
            <td>
              <Link className="btn btn-info" to={"/usuario/pedido/" + pedido.id}>
                VER
              </Link>
            </td>
          </tr>;
      })
  }

    return (
      <section className="row mb-5 sombraHead mt-3 clearfix" >
        <div className="col-md-4 mb-3">
          <Menu salirAct={this.props.signOut}/>
        </div>
        <div className="col-md-6 mb-3">
          <h1 className="display-4">Pedidos</h1>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Fecha</th>
                <th scope="col">Detalle</th>
                <th scope="col">Monto</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {listaPedidos}
            </tbody>
          </table>
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => {
	return {
    	usuario: state.usuario,
      pedidos:state.pedidos
  	}
}

const mapDispatchToProps = dispatch => {
  return {
    signOut: () => {
      dispatch(signOut())
    },
    getPedidos:(uid) => {
      dispatch(getPedidos(uid))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pedidos)




// WEBPACK FOOTER //
// ./src/containers/lista_pedidos.js